export const CONFIG_FETCHER_ACTIONS = {
  FETCH_CONFIG_DATA_SUCCESS: "FETCH_CONFIG_DATA_SUCCESS",
  FETCH_CONFIG_DATA_ERROR: "FETCH_CONFIG_DATA_ERROR",
  FETCH_COLOR_PALETTE_DATA_SUCCESS: "FETCH_COLOR_PALETTE_DATA_SUCCESS",
  FETCH_COLOR_PALETTE_DATA_ERROR: "FETCH_COLOR_PALETTE_DATA_ERROR",
  FETCH_USER_TYPE_SUCCESS: "FETCH_USER_TYPE_SUCCESS",
  FETCH_USER_TYPE_ERROR: "FETCH_USER_TYPE_ERROR",
  COLORS_UPDATED : "COLORS_UPDATED",
  FETCH_LANGUAGE_PREFERENCES: "FETCH_LANGUAGE_PREFERENCES"
};


export const colorsUpdated = () => {
  return{
    type : CONFIG_FETCHER_ACTIONS.COLORS_UPDATED
  }
}